// extracted by mini-css-extract-plugin
module.exports = {"fancyHeader":"fancy-header-module--fancyHeader--1tWmi","fancyTitle":"fancy-header-module--fancyTitle--uPOUA","fancyRule":"fancy-header-module--fancyRule--2nc9a"};